import { NgModule } from '@angular/core';
import { WelcomePage } from './welcome.page';
import { Routes, RouterModule } from '@angular/router';
import { AutoLoginGuard } from 'src/app/guards/auto-login.guard';

const routes: Routes = [
  {
    path: '',
    component: WelcomePage,
    canActivate: [AutoLoginGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WelcomePageRoutingModule { }
